import i18next from 'i18next'

export const getTranslation = (translate, options = null) =>
  i18next.t(translate, options)
